import type { TFunction } from "react-i18next"

import type { Outcome } from "./types.ts"

export const reasonText = (
  t: TFunction,
  reason: string | null | undefined,
  fallback: string
): string =>
  reason
    ? t(`signing.refused.${reason}.detail`, { defaultValue: fallback })
    : fallback

export const refusalText = (t: TFunction, outcome: Outcome<unknown>): string =>
  reasonText(t, outcome.reason, outcome.detail ?? t("signing.sign.failed"))
